// extracted by mini-css-extract-plugin
export default {"faqContainer":"FAQ_faqContainer__z1eYd","faqTitle":"FAQ_faqTitle__kyavx","item":"FAQ_item__SlEmn"};